import { Box, DialogTitle, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { ProjectTimeLogEntry, TimeLogEntry } from "@repo/server-api";
import dayjs from "dayjs";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";

export default function DialogLogs(
	props: Readonly<{
		open: boolean;
		setOpen: (value: boolean) => void;
		logs: ProjectTimeLogEntry[] | TimeLogEntry[];
		addLog: (message: string) => Promise<void>;
	}>,
) {
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);

	const [message, setMessage] = useState<string>("");
	const [errors, setErrors] = useState<{ message?: string }>({});

	useEffect(() => {
		setOpen(props.open);
	}, [props.open]);

	const handleClose = () => {
		setOpen(false);
		props.setOpen(false);
	};

	const addLog = () => {
		if (!message || message.trim() === "") {
			setErrors({
				message: t("message.required", { ns: "validation" }),
			});
			return;
		}
		props.addLog(message).then(() => {
			setMessage("");
			setErrors({});
		});
	};

	return (
		<Dialog
			open={open}
			data-testid="confirmation-dialog"
			aria-describedby="alert-dialog-description"
			maxWidth="md"
			fullWidth>
			<DialogTitle>{t("logs")}</DialogTitle>
			<DialogContent>
				<Box component="section" sx={{ p: 2, position: "relative", height: "100%" }}>
					<Box
						sx={{
							position: "relative",
							height: "300px",
							top: 0,
							overflowY: "auto",
						}}>
						{props.logs.length > 0
							? props.logs.map((log, index) => (
									<div
										key={index}
										style={{
											marginBottom: "10px",
											backgroundColor: "#f5f5f5",
											padding: "10px",
											borderRadius: "4px",
											border: "1px solid #000",
											color: "#000",
										}}>
										<div style={{ fontWeight: "bold", padding: 0, margin: 0 }}>
											{log.createdBy.displayName}
										</div>
										<br />
										<div
											style={{
												fontStyle: "italic",
												color: "#333",
												padding: 0,
												margin: 0,
											}}>
											{log.message}
										</div>
										<br />
										<div style={{ fontSize: "0.6em", color: "#888" }}>
											{dayjs(log.timestamp).format("DD/MM/YYYY HH:mm:ss")}
										</div>
									</div>
								))
							: t("no-logs-to-display")}
					</Box>
					<TextField
						onChange={(event) => {
							setMessage(event.target.value);
							setErrors({
								...errors,
								message: "",
							});
						}}
						className="w-100"
						sx={{
							position: "relative",
							bottom: 0,
							left: 0,
							right: 0,
							marginTop: 2,
						}}
						error={!!errors?.message}
						helperText={errors?.message}
						value={message ?? ""}
						label={t("message")}
						variant="outlined"
						rows={4}
						multiline
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} autoFocus>
					{t("cancel")}
				</Button>
				<Button onClick={addLog}>{t("send")}</Button>
			</DialogActions>
		</Dialog>
	);
}
